import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { suppliersApi } from '../services/api';

export function SuppliersPage() {
  const [q, setQ] = useState('');
  const list = useQuery({
    queryKey: ['suppliers', q],
    queryFn: () => suppliersApi.list({ q: q || undefined, limit: 200 }),
  });

  return (
    <div className="space-y-6">
      <div className="flex items-baseline justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">Fournisseurs</h1>
        <span className="text-sm text-slate-500">{list.data?.total ?? 0} résultat(s)</span>
      </div>

      <input
        type="search"
        placeholder="Rechercher un fournisseur…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="w-full max-w-md rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {list.isLoading ? (
        <p className="text-slate-500">Chargement…</p>
      ) : list.isError ? (
        <p className="text-red-600">Erreur : {String(list.error)}</p>
      ) : (
        <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 text-left">
              <tr>
                <th className="px-4 py-2 font-medium">Nom</th>
                <th className="px-4 py-2 font-medium">Pays</th>
                <th className="px-4 py-2 font-medium">SIRET</th>
                <th className="px-4 py-2 font-medium">Type de charge</th>
                <th className="px-4 py-2 font-medium">Compte</th>
                <th className="px-4 py-2 font-medium">Mode paiement</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {(list.data?.suppliers ?? []).map((s) => (
                <tr key={s.id}>
                  <td className="px-4 py-2 font-medium">{s.name}</td>
                  <td className="px-4 py-2">{s.country}</td>
                  <td className="px-4 py-2 text-slate-600 font-mono text-xs">
                    {s.siret ?? '-'}
                  </td>
                  <td className="px-4 py-2 text-slate-600">{s.default_charge_type ?? '-'}</td>
                  <td className="px-4 py-2 text-slate-600 font-mono text-xs">
                    {s.default_account ?? '-'}
                  </td>
                  <td className="px-4 py-2 text-slate-600">{s.default_payment_mode ?? '-'}</td>
                </tr>
              ))}
              {list.data && list.data.suppliers.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-slate-400 italic">
                    Aucun fournisseur.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
